import { useDialogStore } from "@/store/dialogStore.tsx";
import { Dialog, DialogContent } from "@/components/ui/dialog.tsx";
import { cn } from "@/lib/utils.ts";

export function DialogProvider() {
    const { stack, pop } = useDialogStore();

    return (
        <>
            {stack.map((entry, index) => {
                const isTop = index === stack.length - 1;
                return (
                    <Dialog
                        key={entry.id}
                        open={entry.open}
                        onOpenChange={(open) => {
                            if (!open && isTop) {
                                if (entry.modal) return;
                                pop();
                            }
                        }}>
                        <DialogContent
                            disableCloseButton={entry.disableCloseButton}
                            onPointerDownOutside={(e) => {
                                if (entry.modal) e.preventDefault();
                            }}
                            onInteractOutside={(e) => {
                                if (entry.modal) e.preventDefault();
                            }}
                            onEscapeKeyDown={(e) => {
                                if (entry.modal) e.preventDefault();
                            }}
                            className={cn(
                                "max-h-[95vh] flex flex-col",
                                entry.bigWidth &&
                                    "sm:w-max sm:min-w-lg sm:max-w-[90vw]",
                            )}>
                            <div className="flex flex-col gap-4 overflow-y-auto px-2">
                                {entry.content}
                            </div>
                        </DialogContent>
                    </Dialog>
                );
            })}
        </>
    );
}
